import { CrudModel } from './_crud';

export class UserModel extends CrudModel {
	constructor() {
		super('admin/user');
	}
}

export default new UserModel();
